import * as types from "./actionTypes";
import * as catalogApi from "../api/catalogApi";
import * as songsApi from "../api/songsApi";
import { showNotice } from "./noticeActions";
import { failureMessage, isForbidden } from "../api/client";

export const setCatalogSearch = (term) => ({ type: types.CATALOG_SEARCH_CHANGE, term });

export const setCatalogFilter = (filter) => ({ type: types.CATALOG_SET_FILTER, filter });

/** Searches the catalog. Results for a term that is no longer current are ignored by the reducer. */
export const searchCatalog = (term) => async (dispatch) => {
  const trimmed = (term || "").trim();
  if (!trimmed) return;
  try {
    const songs = await catalogApi.search(trimmed);
    dispatch({ type: types.CATALOG_SEARCH_RESULTS, term, songs });
  } catch (error) {
    dispatch({ type: types.CATALOG_SEARCH_FAILED, term });
    dispatch(showNotice("Search failed. Check your connection and try again."));
  }
};

// a song was edited (here) or deleted (here or elsewhere)
export const songUpdated = (song) => ({ type: types.SONG_UPDATED, song });
export const songDeleted = (songId) => ({ type: types.SONG_DELETED, songId });

/** Deletes a song from the catalog (host only). Resolves true when it is gone. */
export const deleteSong = (songId) => async (dispatch) => {
  try {
    await songsApi.deleteSong(songId);
    dispatch(songDeleted(songId));
    return true;
  } catch (error) {
    dispatch(
      showNotice(
        isForbidden(error)
          ? failureMessage(error, "Only a session host can delete songs.")
          : failureMessage(error, "Couldn't delete the song. Check your connection and try again.")
      )
    );
    return false;
  }
};

export const loadTopSongs = () => async (dispatch) => {
  try {
    const songs = await catalogApi.getTopSongs();
    dispatch({ type: types.CATALOG_TOP_SONGS, songs });
  } catch (error) {
    console.error("Could not load popular songs", error);
  }
};

/** Songs sung in sessions this device's host ran (for the "Sung before" filter). */
export const loadSungBefore = () => async (dispatch, getState) => {
  if (!getState().host.hasKey) {
    dispatch({ type: types.CATALOG_SUNG_BEFORE, songs: [] });
    return;
  }
  try {
    const songs = await catalogApi.sungBefore();
    dispatch({ type: types.CATALOG_SUNG_BEFORE, songs });
  } catch (error) {
    console.error("Could not load the songs sung before", error);
  }
};

/** Fetches a song's verses (search results only carry Id and Title). */
export const loadSong = (songId) => async (dispatch) => {
  try {
    const song = await songsApi.getSong(songId);
    dispatch({ type: types.CATALOG_SONG_LOADED, song });
    return song;
  } catch (error) {
    console.error("Could not load song", error);
    return null;
  }
};
